import { faCross, faMultiply } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
// import logo from "../../images/logo.png";

const LegalPopupModal = ({
  isOpen,
  handleLegalPopup,
  handleDisclaimerCancel,
  handleClose,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed z-50 inset-0 overflow-y-auto">
      <div className="absolute inset-0 bg-black opacity-75"></div>

      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>
        <div className="px-2 fixed z-50 inset-0 overflow-y-auto flex items-center justify-center">
          <div className="legal-dec bg-white rounded-lg w-full shadow-xl max-w-lg mx-auto sm:my-8 p-6 relative">
            {/* <button
              onClick={handleClose}
              className="absolute top-4 right-4 z-50 text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <FontAwesomeIcon icon={faMultiply} className="w-6 h-6 px-2 py-2" />
            </button> */}

            <div className="flex justify-center items-center mb-4">
              <img src={"/qushi_logo.png"} alt="Logo" className="h-16 w-auto" />
            </div>

            <h2 className="text-lg font-bold text-primaryColor mb-4">
              {"Legal Disclaimer"}
            </h2>
            {/* <div className="flex items-start mb-6">
              <p className="text-sm text-start text-gray-500">
                Neither QUSHi nor its Participants are Registered Investment
                Advisors. This service does not constitute financial advice and
                is intended for educational purposes only. It's a live game and
                trading is free.
              </p>
            </div> */}

            <div className="mb-6">
              <p className="text-sm text-center text-gray-500">
                QUSHi is not a Registered Investment Advisor.
                <br />
                This platform is for educational purposes only and does not constitute financial advice.
              </p>
            </div>

            <div className="w-full">
              <button

                className="w-full bg-primaryColor hover:bg-primaryColor text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                onClick={handleLegalPopup}
              >
                 I Agree
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalPopupModal;
